import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { Project } from '@src/app/models/project';
import { environment } from '@src/environments/environment';
import { Orgfile } from '../model/orgfile';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class FilelistService {

  constructor(private http:HttpClient) { }

  // Function to fetch file content as Blob from a signed URL
  fetchFileContent(signedUrl: string): Observable<Blob> {
    return this.http.get(signedUrl, { responseType: 'blob' });
  }

  // GET	    /organization/{organizationId}/project/{projectId}/file/list 		apptable	organizationfile_{organizationId}	file_{projectId}_	
  getFilelist(){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.get<Orgfile[]>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/project/'+SessionHelper.getCurrentProject()+'/file/list',httpOptions);

  }
    getTaskFilelist(projectId: string){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.get<Orgfile[]>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/project/'+projectId+'/file/list',httpOptions);

  }

    // GET	    /organization/{organizationId}/project/list/file/list 		apptable	organizationfile_{organizationId}	file_{projectId}_	
    getOrgFilelist(orgId:string){
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        })
      }
      return this.http.get<Orgfile[]>(environment.apiUrl+'/organization/'+orgId+'/project/list/file/list',httpOptions);
  
    }
      // GET	    /organization/{organizationId}/project/list/file/list 		apptable	organizationfile_{organizationId}	file_{projectId}_	
      getCustomerFilelist(customerId:string){
        return this.getOrgFilelist(SessionHelper.getChoosenOrg()).pipe(
          map((files: Orgfile[]) => {
            const normalizedCustomerId = (customerId || '').split('_')[0];
            return (files || []).filter((file) => {
              const fileCustomerId = file && file.customerId ? file.customerId.split('_')[0] : '';
              return Boolean(fileCustomerId && normalizedCustomerId && fileCustomerId === normalizedCustomerId);
            });
          })
        );
    
      }
  getSignedUrl(file:string){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    }
      const body = JSON.stringify({ Key: file });
      return this.http.post<any>(environment.apiUrl+'/docstore/getsignedgeturl',body,httpOptions);

   
  }

  deleteFile(file:Orgfile){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.delete<any>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/project/'+file.projectId+'/file/'+file.fileId,httpOptions);

  }
    //GET	    /customer/{customerId}/project/list/pit/{pitdate}
    getCustomerProjects(pit:string,customerId:string){
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        })
      }
      return this.http.get<Project[]>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/customer/'+customerId.split('_')[0]+'/project/list/pit/'+pit,httpOptions);
  
    }
    // getOrgProjects(){
    //   const httpOptions = {
    //     headers: new HttpHeaders({
    //       'Content-Type': 'application/json'
    //     })
    //   }
    //   return this.http.get<Project[]>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/organizationproject/list',httpOptions)
    // }
}
